/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { agentListAiScanTargets } from "../funcs/agentListAiScanTargets.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListAiScanTargetsResult } from "../models/components/listaiscantargetsresult.js";
import {
  ListAiScanTargetsRequest,
  ListAiScanTargetsSecurity,
} from "../models/operations/listaiscantargets.js";
import { unwrapAsync } from "../types/fp.js";
export type AiScanTargetsQueryData = ListAiScanTargetsResult;

export function prefetchAiScanTargets(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListAiScanTargetsRequest | undefined,
  security?: ListAiScanTargetsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildAiScanTargetsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildAiScanTargetsQuery(
  client$: GramCore,
  request?: ListAiScanTargetsRequest | undefined,
  security?: ListAiScanTargetsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<AiScanTargetsQueryData>;
} {
  return {
    queryKey: queryKeyAiScanTargets({ gramSession: request?.gramSession }),
    queryFn: async function aiScanTargetsQueryFn(
      ctx,
    ): Promise<AiScanTargetsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(agentListAiScanTargets(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyAiScanTargets(
  parameters: { gramSession?: string | undefined },
): QueryKey {
  return ["@gram/client", "agent", "listAiScanTargets", parameters];
}
